import { PMP_EMAIL_DOMAIN } from "../constants/pMpConstants";
import { getUserDetails } from "./isSystemControllerUser";

/**
 * True when the signed-in account is a patientMpower one.
 *
 * Gates the internal development aids (`?pseudo=1`, see pseudoLocale.ts) so a customer cannot
 * be handed a link that makes their own portal unreadable — by accident or otherwise.
 *
 * Matches the **domain**, the same way isSuperAdminUser does, rather than the looser
 * `email.includes("patientmpower")` written inline in a few pages. That substring test also
 * passes for `someone@patientmpower.attacker.example`, which is the whole reason a domain
 * check exists. Those inline copies are pre-existing and left alone here; new code should
 * call this.
 */
export function isPMPUser(): boolean {
  const email = getUserDetails()?.userEmail ?? "";

  return email.toLowerCase().endsWith(PMP_EMAIL_DOMAIN);
}
